import { useState } from 'react';
import Calendar from '../../components/calendar/Calendar';
import '../../components/layout/Layout.css';

const formatTime = t => { if (!t) return "-"; const [h,m] = t.split(':'); const hour=parseInt(h); return `${hour>12?hour-12:hour||12}:${m} ${hour>=12?'PM':'AM'}`; };
const formatDate = d => { if (!d) return "-"; const parts = d.split('T')[0].split('-'); const date = new Date(parseInt(parts[0]),parseInt(parts[1])-1,parseInt(parts[2])); return date.toLocaleDateString('en-US',{weekday:'long',month:'long',day:'numeric',year:'numeric'}); };

function SessionModal({ session, onClose }) {
  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal" style={{ maxWidth:'480px' }}>
        <div className="modal-header"><span className="modal-title">SESSION DETAILS</span><button className="modal-close" onClick={onClose}>x</button></div>
        <div className="modal-body">
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px' }}>
            {[['Date',formatDate(session.session_date)],['Time',formatTime(session.start_time)+' - '+formatTime(session.end_time)],['Instructor',session.instructor_first+' '+session.instructor_last],['Parent',session.parent_first+' '+session.parent_last],['Player',session.player_first?session.player_first+' '+session.player_last:'-'],['Duration',session.duration_minutes+' min'],['Status',session.status],['Type',session.session_type]].map(([label,value]) => (
              <div key={label} style={{ background:'var(--bg-elevated)', borderRadius:'var(--radius-md)', padding:'10px 14px' }}>
                <div style={{ fontSize:'0.7rem', color:'var(--text-muted)', textTransform:'uppercase', letterSpacing:'0.08em', fontWeight:'600', marginBottom:'4px' }}>{label}</div>
                <div style={{ fontSize:'0.875rem', color:'var(--text-primary)', fontWeight:'500', textTransform: label==='Status'||label==='Type' ? 'capitalize' : 'none' }}>{value}</div>
              </div>
            ))}
          </div>
          {session.notes && (
            <div style={{ background:'var(--bg-elevated)', borderRadius:'var(--radius-md)', padding:'12px 14px' }}>
              <div style={{ fontSize:'0.7rem', color:'var(--text-muted)', textTransform:'uppercase', letterSpacing:'0.08em', fontWeight:'600', marginBottom:'6px' }}>Notes</div>
              <p style={{ fontSize:'0.875rem', color:'var(--text-secondary)', lineHeight:'1.5' }}>{session.notes}</p>
            </div>
          )}
        </div>
        <div className="modal-footer"><button className="btn btn-outline btn-sm" onClick={onClose}>Close</button></div>
      </div>
    </div>
  );
}

export default function AdminCalendar() {
  const [selectedSession, setSelectedSession] = useState(null);
  return (
    <div className="page">
      <div className="page-header"><h1 className="page-title">CALENDAR</h1><p className="page-subtitle">All sessions across all instructors</p></div>
      <Calendar apiEndpoint="/api/admin/calendar" onSessionClick={setSelectedSession} role="admin" />
      {selectedSession && <SessionModal session={selectedSession} onClose={() => setSelectedSession(null)} />}
    </div>
  );
}
